// extracted by mini-css-extract-plugin
module.exports = {"project-SDG":"ProjectSdgDetailsList_project-SDG__niXJ4","SDG-image":"ProjectSdgDetailsList_SDG-image__kOaAN","SDG-description":"ProjectSdgDetailsList_SDG-description___DBiE"};